<template>
    <span>
        <el-button type="primary" size="small" @click="dialogFormVisible = true" >{{buttonName}}</el-button>
        <el-dialog :title="title" :visible.sync="dialogFormVisible" center @close="searchConfigClose">
            <div v-for="(group, index) in fields" :key="index">
                <el-row class="searchSection">
                    <el-col :span="6">
                        {{group.label}}
                    </el-col>
                    <el-col :span="3" :offset="15">
                        <el-checkbox :indeterminate="group_form[group.field + '_is_indeterminate']" v-model="group_form[group.field + '_check_all']" @change="handleCheckAllChange($event, group)">全选</el-checkbox>
                    </el-col>
                    <el-divider class="el-divider-config"></el-divider>
                </el-row>
                <el-checkbox-group v-model="group_form[group.field + '_check_fields']" @change="handleCheckedChange($event, group)">
                    <el-checkbox v-for="(child, child_index) in group.children" :label="child.field" :key="child_index">{{child.label}}</el-checkbox>
                </el-checkbox-group>
                <br>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="exportFile" :loading="exportButtonLoading">导 出</el-button>
            </div>
        </el-dialog>
    </span>
</template>
<style scoped>
  .el-divider-config {
    margin: 35px 10px 0 0;
  }
</style>
<script>
import UserPathConfigService from '~/services/UserPathConfig';
import axios from 'axios';

export default{
    components: {
    },
    
    props: {
        path: {
            type: String,
            required: true,
        },
        tab: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            default: ''
        },
        buttonName: {
            type: String,
            default: '导出',
        },
        params: {
            type: Object,
            required: false,
            value: function () {
                return {};
            }
        },
        url: {
            type: String,
            required: true,
        },
        export_field_list: {
            type: Array,
            required: true,
        },

        filename: {
            type: String,
            required: true,
        },
        cache_field: {
            type: String,
            required: true,
        },
    },
    
    data() {
        return {
            dialogFormVisible: false,
            group_form: {},
            checked_field: [],
            isIndeterminate: true,
            checkAll: false,
            exportButtonLoading: false,
            fields: [],
            config_form: {
                path: this.path,
                tab: this.tab,
            },
        }
    },

    created: function () {
        this.getView();
        this.fields = this.export_field_list;
    },
    
    methods: {

        getView(){
            UserPathConfigService.getView({
                path: this.path,
                tab: this.tab,
            }).then(res => {
                if (res.code == 0 && res.data){
                    this.config_form = res.data;
                }
                if (res.code == 0 && res.data && res.data.export_fields){
                    this.fields.forEach(group => {
                        let checked_fields = res.data.export_fields.hasOwnProperty(group.field + '_check_fields') ? res.data.export_fields[group.field + '_check_fields'] : [];
                        
                        // 过滤掉不存在的字段
                        const allFields = group.children.map(child => child.field);
                        checked_fields = checked_fields.filter(field => allFields.includes(field));

                        let checkedCount = checked_fields.length;
                        let is_indeterminate = checkedCount > 0 && checkedCount < group.children.length;
                        let check_all = checkedCount === group.children.length;

                        this.$set(this.group_form, group.field + '_check_fields', checked_fields);
                        this.$set(this.group_form, group.field + '_is_indeterminate', is_indeterminate);
                        this.$set(this.group_form, group.field + '_check_all', check_all);
                    });
                    // console.log('fields:', this.fields, res.data.export_fields, this.group_form);
                }else{
                    this.fields.forEach(group => {
                        this.$set(this.group_form, group.field + '_is_indeterminate', false);
                        this.$set(this.group_form, group.field + '_check_fields', []);
                        this.$set(this.group_form, group.field + '_check_all', false);
                        //默认是全选中
                        this.handleCheckAllChange(true, group);
                    });
                }
            });
        },

        handleCheckAllChange(value, group) {
            
            const allFields = [];
            group.children.forEach(child => {
                allFields.push(child.field);
            });
            this.group_form[group.field + '_check_fields'] = value ? allFields : [];
            this.group_form[group.field + '_check_all'] = value;
            this.group_form[group.field + '_is_indeterminate'] = false;
            // console.log('全选: ', value, group, this.group_form);
        },

        handleCheckedChange(value, group) {
            let checkedCount = value.length;
            this.group_form[group.field + '_check_fields'] = value;
            this.group_form[group.field + '_is_indeterminate'] = checkedCount > 0 && checkedCount < group.children.length;
            this.group_form[group.field + '_check_all'] = checkedCount === group.children.length;
            // console.log('单个勾选: ', value, group, this.group_form);
        },

        searchConfigClose(){
            // this.$emit("close", true);
        },

        exportFile() {
            this.exportButtonLoading = true;
            this.config_form['export_fields'] = this.group_form;
            let servcie;
            if(this.config_form.id){
                servcie = UserPathConfigService.update(this.config_form);
            }else{
                servcie = UserPathConfigService.create(this.config_form);
            }
            servcie.then(res => {
                if (res.code == 0 && res.data){
                    this.config_form.id = res.data.id;
                    this.checked_field = [];
                    this.fields.forEach(group => {
                        this.group_form[group.field + '_check_fields'].forEach(field => {
                            this.checked_field.push(field);
                        });
                    });
                    if(this.checked_field.length == 0){
                        this.$message({
                            message: '请选择导出字段',
                            type: "error"
                        });
                        return;
                    }
                    
                    let params = this.params;
                    params['field_list'] = this.checked_field;
                    params['access-token'] = this.$store.getters.token;
                    _.each(params, (val, key) => {
                        // 如果值是假值，除了数字 0 和字符串 '0'，都删除该键
                        if (val === undefined || val === null || (typeof val === 'string' && val === '')) {
                            delete params[key];
                        }
                    });
                    axios({
                        url: this.url,
                        method: 'GET',
                        responseType: 'blob',
                        params: params
                    })
                    .then(response => {
                        const contentType = response.headers['content-type'];
                        if (contentType && contentType.includes('application/json')) {
                            // JSON 响应处理
                            response.data.text().then(jsonText => {
                                const res = JSON.parse(jsonText);
                                // 在这里处理 jsonData
                                if (res.code != 0) {
                                    this.$message({
                                    message: res.msg,
                                    type: 'error'
                                    })
                                }
                            })
                        }else{
                            const blob = new Blob([response.data]);
                            const link = document.createElement('a');
                            link.href = window.URL.createObjectURL(blob);
                            link.download = this.filename + '.xlsx';
                            link.click();
                        }
                        this.exportButtonLoading = false;
                    })
                    .catch(error => {
                        this.exportButtonLoading = false;
                        console.error('Error fetching file:', error);
                    });
                    this.$store.getters.cache[this.cache_field] = this.checked_field;
                }
                this.dialogFormVisible = false;
            }).catch((err) => {
                console.error(err);
                this.loading = false;
            });
            
            // this.$emit("change", this.check_list);
        },
    },
}
</script>



// WEBPACK FOOTER //
// src/widgets/ExportFields.vue